import React from "react";
import TableRow from "../../../../../Components/Common/TableRow";
import TableData from "../../../../../Components/Common/TableData";
import { convertToLocalDateTime } from "../../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../../Components/Common/TableRowPerAction";

const TutoringPurchaseRow = ({ row, onEditClick }) => {
  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row?.package?.title}</TableData>
        <TableData>{row?.amount}</TableData>
        <TableData>{row?.user?.name}</TableData>
        <TableData>{row?.user?.email}</TableData>
        <TableData>{convertToLocalDateTime(row?.createdAt)}</TableData>
        <TableData>
          <span className="capitalize">{row?.packageStatus}</span>
        </TableData>
        <TableRowPerAction onEdit={() => onEditClick(row)} />
      </TableRow>
    </>
  );
};

export default TutoringPurchaseRow;
